export const onlyDocumentDigits = (value: string): string => {
    return (value ?? "").replace(/\D/g, "");
};

export const normalizeCpfCnpj = (value: string): string => {
    const digits = onlyDocumentDigits(value);

    if (digits.length > 11 && digits.length < 14) {
        return digits.slice(0, 11);
    }

    return digits.slice(0, 14);
};

export const documentMask = (value: string) => {
    if (!value) {
        return "";
    }

    const digits = onlyDocumentDigits(value);
    const isCnpj =
        digits.length >= 14 || (digits.length > 11 && value.length > 14);

    if (isCnpj) {
        const cnpj = digits.slice(0, 14);

        return cnpj
            .replace(/^(\d{2})(\d)/, "$1.$2")
            .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
            .replace(/\.(\d{3})(\d)/, ".$1/$2")
            .replace(/(\d{4})(\d)/, "$1-$2");
    }

    const cpf = digits.slice(0, 11);

    return cpf
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
};
